import Vue from 'vue'
import Router from 'vue-router'
import B2B from './modules/b2b'
import { Modal } from './views/b2b/api/model.js'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: '/newshareh5/',
    routes: [
        ...B2B
    ],
    // scrollBehavior (to, from, savedPosition) {
    //     if (savedPosition) {
    //         return savedPosition
    //     } else {
    //         return { x: 0, y: 0 }
    //     }
    // }
    // 缓存页面指定返回到对应的位置
    scrollBehavior (to, from, savedPosition) {
        // keep-alive 返回缓存页面后记录浏览位置
        if (savedPosition && to.meta.keepAlive) {
            return savedPosition
        }
        // 异步滚动操作
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({ x: 0, y: to.meta.savedPosition || 0 })
            }, 0)
        })
    }
})

router.beforeEach(async (to, from, next) => {
    window.document.title = to.meta.title
    if (to.path.indexOf('b2b') > 0) {
        Modal.beforeClose()
        let user = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
        let arr = [
            'regist', // 注册页面
            'registerSuccess', // 注册成功页面
            'registerServer', // 注册协议
            'server2', // 服务协议
            'memberServer', // 会员服务协议
            'conceal', // 隐私政策
            'downdfx', // 单分享下载
            'downdfx2', // 单分享下载
            'shareGoods', // 商品分享详情
            'presellActivityGoodDetail', // 预售分享详情
            'salesServer', // 售后规则
            'special', // 专题活动
            'specialList', // 专题活动列表,
            'dataBank' // 资料库列表
        ]
        let isPath = !!(arr.indexOf(to.name) >= 0)
        if (!user && !to.query.isWeixin && !isPath) {
            await router.app.$options.store.dispatch('getUserInfoData').then((data) => {
                if (!data.companyCode) {
                    next('/b2b/common/runArea')
                }
                next()
            })
        } else if (user && !user.companyCode && to.name !== 'runArea' && !isPath) {
            next('/b2b/common/runArea')
        }
    }
    next()
})
export default router
